import { useEffect } from 'react';
import { AppRouter } from './router';
import { AppProvider } from './providers/provider';
import {
  attachAuthInterceptor,
  attachSessionResetInterceptor,
} from '~shared/api/api.instance';
import { store } from '~shared/store';
import { queryClient } from '~shared/query-client';
import { sessionActions } from '~entities/session/model/session.slice';
import { SESSION_ROOT_QUERY_KEY } from '~entities/session/api/session.queries';
import { initializeFocusDetection } from '~shared/lib/accessibility/focus-detection';

attachAuthInterceptor(() => store.getState().session?.sessionId);
attachSessionResetInterceptor(() => {
  store.dispatch(sessionActions.resetSession());
  queryClient.invalidateQueries({ queryKey: SESSION_ROOT_QUERY_KEY });
});

export const App = () => {
  // Initialize focus detection on mount
  useEffect(() => {
    const cleanup = initializeFocusDetection();
    return cleanup;
  }, []);

  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
};
